import { Component, inject, signal, computed, HostListener, OnInit } from '@angular/core';
import { ChoosePlanService } from './service/choose-plan/choose-plan.service';
import { NgxVortexComponent } from '@omnedia/ngx-vortex';
import { SubscriptionService } from '../../services/subscription/subscription.service';
import { environment } from '../../../environments/environment';
import { ViewportOverlayDirective } from '../../common/directives/viewport-overlay/viewport-overlay.directive';



@Component({
  selector: 'app-choose-plan',
  imports: [],
  hostDirectives: [ViewportOverlayDirective],
  templateUrl: './choose-plan.component.html',
  styleUrl: './choose-plan.component.css',
})
export class ChoosePlan implements OnInit {
  
  subscriptionLoadingCtrl = signal<boolean>(false);

  /** Services */
  public choosePlanService = inject(ChoosePlanService);
  public subscriptionService = inject(SubscriptionService);
  /** Services END */

  

  /** State – single plan (Essential) always selected */
  // selectedPlan = signal<string>('essential');
  // selectedBoltOns = signal<Set<string>>(new Set());
  showAllBoltOnDetails = signal(false);
  isAnnual = signal(false);

  totalMonthly = computed(() => {
    const plan = this.choosePlanService.subscriptionPlans[0];
    const planPrice = plan ? (this.isAnnual() ? plan.price * 0.83 : plan.price) : 0;
    const boltOnsPrice = Array.from(this.subscriptionService.selectedBoltOns()).reduce((sum, id) => {
      const boltOn = this.choosePlanService.boltOns.find(b => b.stripe_id === id);
      return sum + (boltOn ? boltOn.price : 0);
    }, 0);
    return Math.round(planPrice + boltOnsPrice);
  });

  selectedPlanName = computed(() => this.choosePlanService.subscriptionPlans[0]?.name ?? '');
  /** State END */


  @HostListener('document:keydown.escape')
  onEscape() {
    this.closeModal();
  }

  ngOnInit(): void {
    this.choosePlanService.preSelectedBoltOns().forEach(boltOn => {
      this.subscriptionService.selectedBoltOns.update(current => {
        const newSet = new Set(current);
        newSet.add(boltOn);
        return newSet;
      });
    });
  }

  closeModal() {
    this.choosePlanService.closeAllModals();
  }

  toggleBoltOn(boltOnStripeId: string) {
    this.subscriptionService.selectedBoltOns.update(current => {
      const newSet = new Set(current);
      if (newSet.has(boltOnStripeId)) {
        newSet.delete(boltOnStripeId);
      } else {
        newSet.add(boltOnStripeId);
      }
      return newSet;
    });
  }

  isBoltOnSelected(boltOnStripeId: string): boolean {
    return this.subscriptionService.selectedBoltOns().has(boltOnStripeId);
  }

  isBoltOnIncluded(_boltOnStripeId: string): boolean {
    return false; // Essential Plan: bolt-ons are always optional paid add-ons
  }

  toggleBoltOnInfo(_boltOnStripeId: string) {
    this.showAllBoltOnDetails.update(v => !v);
  }

  isBoltOnInfoExpanded(_boltOnStripeId: string): boolean {
    return this.showAllBoltOnDetails();
  }

  toggleBilling() {
    this.isAnnual.update(v => !v);
  }

  subscribe() {
    console.log('🤑🤑🤑 subscribe() 🤑🤑🤑')

    this.subscriptionLoadingCtrl.set(true);

    const boltOns = Array.from(this.subscriptionService.selectedBoltOns());
    console.log('Bolt-ons:', boltOns);
    console.log('Subscribing to:', { plan: 'essential', boltOns, annual: this.isAnnual(), total: this.totalMonthly() });
    // Handle subscription logic here
    this.subscriptionService.setSubscriptionLevel('essentials', 'gbp');
    this.subscriptionService.successUrl.set(`${window.location.protocol}//${window.location.host}/thankyou-brand`);

    this.subscriptionService.signUpSubscription();
  }
}
